import { render, staticRenderFns } from "./l-menu.vue?vue&type=template&id=07f8d3e0&scoped=true"
import script from "./l-menu.vue?vue&type=script&lang=js"
export * from "./l-menu.vue?vue&type=script&lang=js"
import style0 from "./l-menu.vue?vue&type=style&index=0&id=07f8d3e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f8d3e0",
  null
  
)

export default component.exports